import Header from "components/Layouts/Header"
import styled from "styled-components"

const StyledPage = styled.div<{ $theme: "light" | "dark" }>`
  height: 100%;
  --header-height: 44px;
  background: ${(props) => (props.$theme === "light" ? "#fff" : "#00263a")};
  color: ${(props) => (props.$theme === "light" ? "#00263A" : "#fff")};
`

const StyledPageBody = styled.div`
  height: calc(100% - var(--header-height));
  overflow-y: auto;
`

interface IPageProps {
  title?: string
  onBack?: () => void
  children: any
  theme?: "light" | "dark"
  background?: string
  rightAction?: React.ReactNode
  noLeftAction?: boolean
  isAppPaddingStyle?: boolean
}

const Page = (props: IPageProps) => {
  const {
    title = "",
    onBack,
    children,
    theme = "light",
    background,
    rightAction,
    noLeftAction,
    isAppPaddingStyle,
  } = props
  return (
    <StyledPage $theme={theme} style={{ background }}>
      <Header
        noLeftAction={noLeftAction}
        title={title}
        onBack={onBack}
        theme={theme}
        rightAction={rightAction}
        isAppPaddingStyle={isAppPaddingStyle}
      />
      <StyledPageBody>{children}</StyledPageBody>
    </StyledPage>
  )
}

export default Page
